export default "__VITE_ASSET__7bc695ba__"